import assemblyPages from './assemblyPagesData.json';

const assemblyText = (value, lang = 'en') => value[lang === 'pt' ? 1 : lang === 'es' ? 2 : 0];
export { assemblyPages, assemblyText };
